import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
  this.jobApplicationValidaton = function () {
    const dictonary = {
      custom: {
        company: {
          required: () => t.t(dictEnum.LBL_Company) + t.t(dictEnum.WARN_IsRequired)
        },
        engName: {
          required: () => t.t(dictEnum.LBL_EngName) + t.t(dictEnum.WARN_IsRequired)
        },
        chiName: {
          required: () => t.t(dictEnum.LBL_ChiName) + t.t(dictEnum.WARN_IsRequired)
        },
        lastName: {
          required: () => t.t(dictEnum.LBL_LastName) + t.t(dictEnum.WARN_IsRequired)
        },
        chiLastName: {
          required: () => t.t(dictEnum.LBL_LastName) + t.t(dictEnum.WARN_IsRequired)
        },
        address: {
          required: () => t.t(dictEnum.LBL_Address) + t.t(dictEnum.WARN_IsRequired)
        },
        addressEng: {
          required: () => t.t(dictEnum.LBL_Address) + t.t(dictEnum.WARN_IsRequired)
        },
        jobAdCode: {
          required: () => t.t(dictEnum.LBL_JobAdCode) + t.t(dictEnum.WARN_IsRequired)
        },
        nationality: {
          required: () => t.t(dictEnum.LBL_Nationality) + t.t(dictEnum.WARN_IsRequired)
        },
        marriedStatus: {
          required: () => t.t(dictEnum.LBL_MarriedStatus) + t.t(dictEnum.WARN_IsRequired)
        },
        mobile: {
          required: () => t.t(dictEnum.LBL_Mobile) + t.t(dictEnum.WARN_IsRequired)
        },
        dob: {
          required: () => t.t(dictEnum.LBL_DOB) + t.t(dictEnum.WARN_IsRequired)
        },
        email: {
          required: () => t.t(dictEnum.LBL_Email) + t.t(dictEnum.WARN_IsRequired)
        },
        academicCode: {
          required: () => t.t(dictEnum.LBL_Academic) + t.t(dictEnum.WARN_IsRequired)
        },
        major: {
          required: () => t.t(dictEnum.LBL_Major) + t.t(dictEnum.WARN_IsRequired)
        },
        institueName: {
          required: () => t.t(dictEnum.LBL_InstituteName) + t.t(dictEnum.WARN_IsRequired)
        },
        emploType: {
          required: () => t.t(dictEnum.LBL_Type) + t.t(dictEnum.WARN_IsRequired)
        },
        postJoin: {
          required: () => t.t(dictEnum.LBL_JoinPosition) + t.t(dictEnum.WARN_IsRequired)
        },
        postLeft: {
          required: () => t.t(dictEnum.LBL_LastPosition) + t.t(dictEnum.WARN_IsRequired)
        },
        leaveReason: {
          required: () => t.t(dictEnum.LBL_ReasonLeave) + t.t(dictEnum.WARN_IsRequired)
        },
      }
    };
    Validator.localize('en', dictonary);
  }
}



// WEBPACK FOOTER //
// ./src/components/S090000-Candidate/S090300-JobApplication/S090300-JobApplicationValidaton.js